/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * close Icon
 *
 * @file CloseIcon.jsx
 * @author Ujjwal Sana
 */

import React from 'react';

// eslint-disable-next-line no-unused-vars
const CloseIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M5 3.67193L8.39688 0.275052C8.76362 -0.091684 9.35821 -0.091684 9.72495 0.275052C10.0917 0.641788 10.0917 1.23638 9.72495 1.60312L6.32807 5L9.72495 8.39688C10.0917 8.76362 10.0917 9.35821 9.72495 9.72495C9.35821 10.0917 8.76362 10.0917 8.39688 9.72495L5 6.32807L1.60312 9.72495C1.23638 10.0917 0.641788 10.0917 0.275052 9.72495C-0.091684 9.35821 -0.091684 8.76362 0.275052 8.39688L3.67193 5L0.275052 1.60312C-0.091684 1.23638 -0.091684 0.641788 0.275052 0.275052C0.641788 -0.091684 1.23638 -0.091684 1.60312 0.275052L5 3.67193Z" fill="#171717" />
  </svg>
);

export default CloseIcon;
